// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel_panel__s1zfk","light":"Panel_light__g085V","medium":"Panel_medium__0_ywr","dark":"Panel_dark__epRxg","half":"Panel_half__8CzUO"};